// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./upgrade/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-wrapper {
  position: relative;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  border-bottom: 1px solid var(--black1);
}

.status-alert {
  padding: 1rem;
  color: var(--white) !important;
  top: 0;
  width: 100%;
  text-align: center;
  background-color: var(--black7);
  z-index: 999;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
}
@media (max-width: 360px) {
  .status-alert {
    padding: 0.75rem;
    font-size: 13px;
    font-weight: 300;
  }
}
.status-alert.mobile-app {
  display: flex;
  justify-content: space-between;
  background: var(--black4);
  color: white !important;
  position: relative;
  padding-right: 0;
}
.status-alert.mobile-app .mobile-app-container {
  display: flex;
  width: 100%;
  align-items: center;
  color: white !important;
  text-decoration: none;
  border-bottom: none;
}
.status-alert.mobile-app .mobile-app-container:hover {
  color: white !important;
}
.status-alert.mobile-app .mobile-app-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}
.status-alert.mobile-app .mobile-app-header span {
  font-size: 15.5px;
  font-weight: 600;
}
@media (max-width: 360px) {
  .status-alert.mobile-app .mobile-app-header span {
    font-size: 14.5px;
  }
}
.status-alert.mobile-app .mobile-app-header p {
  font-size: 14px;
  margin-bottom: 0;
  font-weight: 300;
}
@media (max-width: 360px) {
  .status-alert.mobile-app .mobile-app-header p {
    font-size: 13px;
  }
}
.status-alert.mobile-app .mobile-app-close-icon {
  display: flex;
  align-items: center;
  padding: 1rem 1rem;
}
@media (max-width: 360px) {
  .status-alert.mobile-app .mobile-app-close-icon {
    padding: 0.5rem;
  }
}
.status-alert.mobile-app .mobile-app-image {
  display: flex;
}
.status-alert.mobile-app .mobile-app-image img {
  min-width: 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.65rem;
  margin-right: 1rem;
}
@media (max-width: 360px) {
  .status-alert.mobile-app .mobile-app-image img {
    margin-right: 0.5rem;
  }
}
.status-alert.upgrade {
  cursor: pointer;
  display: flex;
  justify-content: center;
  background-color: var(--white);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100%;
  position: relative;
  width: 100%;
  padding: 0.5rem 2.5rem;
}
.status-alert.upgrade > a {
  border-bottom: none;
  display: flex;
  width: 100%;
}
.status-alert.upgrade .upgrade-container {
  display: flex;
  width: 100%;
  align-items: center;
  text-decoration: none;
  border-bottom: none;
  justify-content: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: var(--black9) !important;
}
@media (max-width: 768px) {
  .status-alert.upgrade .upgrade-container {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
  }
}
.status-alert.upgrade .upgrade-container:hover {
  color: var(--black9) !important;
}
.status-alert.upgrade .upgrade-header span {
  font-weight: 600;
}
.status-alert.upgrade .upgrade-header p {
  margin-bottom: 0;
  font-weight: 400;
}
.status-alert.upgrade .upgrade-close-icon {
  display: flex;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
  position: absolute;
  z-index: 999;
  right: 0;
  top: 0;
  color: var(--black9) !important;
}
@media (max-width: 768px) {
  .status-alert.upgrade .upgrade-close-icon {
    padding: 1rem;
  }
}
@media (max-width: 360px) {
  .status-alert.upgrade .upgrade-close-icon {
    padding: 0.5rem;
  }
}
.status-alert.upgrade .upgrade-image {
  display: flex;
}
.status-alert.upgrade .upgrade-image img {
  min-width: 2rem;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  margin-right: 0.5rem;
}
.status-alert > p {
  margin: 0;
}
.status-alert.DANGER {
  background: var(--red6);
}
.status-alert.INFO {
  background: var(--purple6);
}
.status-alert.SUCCESS {
  background: var(--green6);
}
.status-alert.WARNING {
  background: var(--orange4);
}
.status-alert a {
  font-weight: 600;
  line-height: 20px;
  border-bottom: 1px solid var(--purple6);
  color: var(--purple6) !important;
}
.status-alert a:hover {
  color: var(--purple4) !important;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/layouts/dashboard/status/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,sCAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,MAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,YAAA;EAEA,gBAAA;EACA,eAAA;EACA,iBAAA;AAAF;AAEE;EAbF;IAcI,gBAAA;IACA,eAAA;IACA,gBAAA;EACF;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AACI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;AACN;AACM;EACE,uBAAA;AACR;AAGI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AADN;AAGM;EACE,iBAAA;EACA,gBAAA;AADR;AAGQ;EAJF;IAKI,iBAAA;EAAR;AACF;AAGM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AADR;AAGQ;EALF;IAMI,eAAA;EAAR;AACF;AAII;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAFN;AAIM;EALF;IAMI,eAAA;EADN;AACF;AAII;EACE,aAAA;AAFN;AAIM;EACE,iBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AAFR;AAIQ;EAPF;IAQI,oBAAA;EADR;AACF;AAOE;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,yDAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AALJ;AAOI;EACE,mBAAA;EACA,aAAA;EACA,WAAA;AALN;AAQI;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;AANN;AAQM;EAdF;IAeI,gBAAA;IACA,eAAA;IACA,iBAAA;EALN;AACF;AAOM;EACE,+BAAA;AALR;AAUM;EACE,gBAAA;AARR;AAWM;EACE,gBAAA;EACA,gBAAA;AATR;AAaI;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,MAAA;EACA,+BAAA;AAXN;AAaM;EAXF;IAYI,aAAA;EAVN;AACF;AAWM;EAdF;IAeI,eAAA;EARN;AACF;AAWI;EACE,aAAA;AATN;AAWM;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;AATR;AAcE;EACE,SAAA;AAZJ;AAeE;EACE,uBAAA;AAbJ;AAgBE;EACE,0BAAA;AAdJ;AAiBE;EACE,yBAAA;AAfJ;AAkBE;EACE,0BAAA;AAhBJ;AAmBE;EACE,gBAAA;EACA,iBAAA;EACA,uCAAA;EACA,gCAAA;AAjBJ;AAmBI;EACE,gCAAA;AAjBN","sourcesContent":[".status-wrapper {\n  position: relative;\n  z-index: 999;\n  top: 0;\n  left: 0;\n  width: 100%;\n  border-bottom: 1px solid var(--black1);\n}\n\n.status-alert {\n  padding: 1rem;\n  color: var(--white) !important;\n  top: 0;\n  width: 100%;\n  text-align: center;\n  background-color: var(--black7);\n  z-index: 999;\n\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 17px;\n\n  @media (max-width: 360px) {\n    padding: .75rem;\n    font-size: 13px;\n    font-weight: 300;\n  }\n\n  &.mobile-app {\n    display: flex;\n    justify-content: space-between;\n    background: var(--black4);\n    color: white !important;\n    position: relative;\n    padding-right: 0;\n\n    .mobile-app-container {\n      display: flex;\n      width: 100%;\n      align-items: center;\n      color: white !important;\n      text-decoration: none;\n      border-bottom: none;\n\n      &:hover {\n        color: white !important;\n      }\n    }\n\n    .mobile-app-header {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      text-align: left;\n\n      span {\n        font-size: 15.5px;\n        font-weight: 600;\n\n        @media (max-width: 360px) {\n          font-size: 14.5px;\n        }\n      }\n\n      p {\n        font-size: 14px;\n        margin-bottom: 0;\n        font-weight: 300;\n\n        @media (max-width: 360px) {\n          font-size: 13px;\n        }\n      }\n    }\n\n    .mobile-app-close-icon {\n      display: flex;\n      align-items: center;\n      padding: 1rem 1rem;\n\n      @media (max-width: 360px) {\n        padding: .5rem;\n      }\n    }\n\n    .mobile-app-image {\n      display: flex;\n\n      img {\n        min-width: 2.5rem;\n        width: 2.5rem;\n        height: 2.5rem;\n        border-radius: 0.65rem;\n        margin-right: 1rem;\n\n        @media (max-width: 360px) {\n          margin-right: .5rem;\n        }\n\n      }\n    }\n  }\n\n  &.upgrade {\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    background-color: var(--white);\n    background-image: url(\"./upgrade/background.png\");\n    background-size: 100%;\n    position: relative;\n    width: 100%;\n    padding: .5rem 2.5rem;\n\n    & > a {\n      border-bottom: none;\n      display: flex;\n      width: 100%;\n    }\n\n    .upgrade-container {\n      display: flex;\n      width: 100%;\n      align-items: center;\n      text-decoration: none;\n      border-bottom: none;\n      justify-content: center;\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 16px;\n      line-height: 24px;\n      color: var(--black9) !important;\n\n      @media (max-width: 768px) {\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 20px;\n      }\n\n      &:hover {\n        color: var(--black9) !important;\n      }\n    }\n\n    .upgrade-header {\n      span {\n        font-weight: 600;\n      }\n\n      p {\n        margin-bottom: 0;\n        font-weight: 400;\n      }\n    }\n\n    .upgrade-close-icon {\n      display: flex;\n      align-items: center;\n      padding: 1rem;\n      cursor: pointer;\n      position: absolute;\n      z-index: 999;\n      right: 0;\n      top: 0;\n      color: var(--black9) !important;\n\n      @media (max-width: 768px) {\n        padding: 1rem;\n      }\n      @media (max-width: 360px) {\n        padding: .5rem;\n      }\n    }\n\n    .upgrade-image {\n      display: flex;\n\n      img {\n        min-width: 2rem;\n        width: 2rem;\n        height: 2rem;\n        border-radius: 0.5rem;\n        margin-right: .5rem;\n      }\n    }\n  }\n\n  & > p {\n    margin: 0;\n  }\n\n  &.DANGER {\n    background: var(--red6);\n  }\n\n  &.INFO {\n    background: var(--purple6);\n  }\n\n  &.SUCCESS {\n    background: var(--green6);\n  }\n\n  &.WARNING {\n    background: var(--orange4);\n  }\n\n  & a {\n    font-weight: 600;\n    line-height: 20px;\n    border-bottom: 1px solid var(--purple6);\n    color: var(--purple6) !important;\n\n    &:hover {\n      color: var(--purple4) !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
